/** Micro-dollars as US dollars with two decimals, never localised (QZ-D55). */
export const formatMicroUsd = (microUsd: number): string => {
  if (microUsd === 0) {
    return '$0.00';
  }
  if (microUsd < 10_000) {
    return '<$0.01';
  }
  const cents = Math.round(microUsd / 10_000);
  const wholeDollars = Math.floor(cents / 100);
  const remainingCents = cents % 100;
  return `$${wholeDollars}.${String(remainingCents).padStart(2, '0')}`;
};
